/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

const qtyInput = document.querySelector(".sticky-quantity-selector  .qty-input");
const wrpqtyInput = document.querySelector("quantity-counter.quantity-selector  .quantity__input");
const qtyPlus = document.querySelector(".sticky-quantity-selector .plus");
const qtyMinus = document.querySelector(".sticky-quantity-selector .minus");
  if(qtyPlus){
    qtyPlus.addEventListener("click", function () {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      wrpqtyInput.value = parseInt(wrpqtyInput.value) + 1;
    });
  }
    if (qtyMinus){
          qtyMinus.addEventListener("click", function () {
          const currentVal = parseInt(qtyInput.value);
          const minVal = parseInt(qtyInput.min);
          if (currentVal > minVal) {
            qtyInput.value = currentVal - 1;
            wrpqtyInput.value = currentVal - 1;
          }
        });  
    }
    




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
